import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  IconButton,
  Divider,
  TextField,
  Avatar,
  Box,
  Autocomplete,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import MenuIcon from "@mui/icons-material/Menu";
//import AddIcon from '@mui/icons-material/Add';
//import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  height: 35,
  borderRadius: 0,
  fontFamily: "Inter, sans-serif",
  "& .MuiInputBase-root": {
    height: 35,
    borderRadius: 0,
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPageIcons() {
  const [loading, setLoading] = useState(false);
  const [iconTiles, setIconTiles] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [collectionOptions, setCollectionOptions] = useState([]);

  useEffect(() => {
    async function fetchData() {
      let resData = await getData("/api/theme/landing_icon?is_admin=true");
      console.log(resData);
      let icons_data = resData["data"]["title_icons"];
      if (icons_data) {
        const filteredIcons = icons_data.filter(
          (icon) => icon.is_header_icon === false
        );

        // Ensure collection and page_link values are properly set
        const updatedIcons = filteredIcons.map((icon) => ({
          ...icon,
          collection: icon.collection?.id || "", // Set collection ID or empty string
          page_link: icon.page_link || "", // Set page_link or empty string
        }));

        setIconTiles(updatedIcons);
      }

      let collectionResData = await getData("/api/product/product-collection");
      let collections_data = collectionResData["data"]["live_collections"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          collection_url: collection.collection_url || "",
        }));
        setCollectionOptions(formattedCollections);
      }

      setLoading(false);
    }

    fetchData();
  }, []);

  const handleToggle = () => {
    setIsVisible((prev) => !prev);
  };

  const handleSaveTile = async (index) => {
    console.log(iconTiles[index]);

    let iconReqData = {
      'id': iconTiles[index].id ? iconTiles[index].id : "",
      'title': iconTiles[index].title ? iconTiles[index].title : "",
      'page_link': iconTiles[index].page_link ? iconTiles[index].page_link : "",
      'orientation_number': iconTiles[index].orientation_number ? iconTiles[index].orientation_number : "",
      'status': iconTiles[index].status ? iconTiles[index].status : "",
      'collection': iconTiles[index].collection ? iconTiles[index].collection : "",
      'collection_name': iconTiles[index].collection_name ? iconTiles[index].collection_name : "",
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    // Only include icon_image if a new image file is uploaded
    if (iconTiles[index].icon_image_file) {
      iconReqData.icon_image = await convertToBase64(iconTiles[index].icon_image_file);
    }

    console.log(iconReqData);

    try {
      let iconResData = await postData(
        "/api/theme/landing_icon",
        iconReqData
      );
      if (iconResData["data"]["code"] === "200") {
        alert("Icon saved successfully.");
      } else {
        alert("Error in saving icon. Please try again.");
      }
    } catch (error) {
      console.error("Error in saving icon:", error);
    }
  };

  const handleVisibilityToggle = async (id, newStatus) => {
    const visibilityReqData = {
      id,
      status: newStatus ? "enabled" : "disabled",
    };

    try {
      let visibilityResData = await postData(
        "/api/theme/landing_icon?is_admin = true",
        visibilityReqData
      );

      if (visibilityResData["data"]["code"] === "200") {
        alert("Tile visibility updated successfully.");
        setIconTiles((prevTiles) =>
          prevTiles.map((tile) =>
            tile.id === id
              ? { ...tile, status: visibilityReqData.status }
              : tile
          )
        );
      } else {
        alert("Error updating tile visibility. Please try again.");
      }
    } catch (error) {
      console.error("Error updating tile visibility:", error);
    }
  };

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width <= 96 && img.height <= 96) {
          setIconTiles((prevTiles) => {
            const newTiles = [...prevTiles];
            newTiles[index] = {
              ...newTiles[index],
              icon_image: imageUrl, // For preview
              icon_image_file: file, // Store the file for saving
            };
            return newTiles;
          });
        } else {
          alert("Image must be 96px wide and 96px tall or smaller.");
        }
      };
    }
  };

  const handleTitleChange = (e, index) => {
    const newTiles = [...iconTiles];
    newTiles[index].title = e.target.value;
    setIconTiles(newTiles);
  };

  const handleLinkChange = (event, newValue, index) => {
    const updatedIconTiles = [...iconTiles];
    if (newValue?.value === "none") {
      updatedIconTiles[index].collection = "";
      updatedIconTiles[index].collection_url = "";
      updatedIconTiles[index].collection_name = "";
      updatedIconTiles[index].page_link = "";
      updatedIconTiles[index].isEditable = true;
    } else {
      updatedIconTiles[index].collection = newValue?.value || "";
      updatedIconTiles[index].collection_url = newValue?.collection_url || "";
      updatedIconTiles[index].collection_name = newValue?.label || "";
      updatedIconTiles[index].page_link = newValue?.collection_url || "";
      updatedIconTiles[index].isEditable = false;
    }
    setIconTiles(updatedIconTiles);
  };

  const handleURLChange = (e, index) => {
    const newTiles = [...iconTiles];
    newTiles[index].page_link = e.target.value;
    setIconTiles(newTiles);
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    // Reorder the tiles array
    const reorderedIconTiles = Array.from(iconTiles); // Replace `items` with your current state variable
    const [removed] = reorderedIconTiles.splice(result.source.index, 1);
    reorderedIconTiles.splice(result.destination.index, 0, removed);

    // Prepare data for submission
    const requestData = {
      order: reorderedIconTiles.map((item, index) => ({
        id: item.id,
        position: index, // Assuming `position` is the field for order
      })),
    };

    try {
      const response = await postData("/api/theme/landing_icon", requestData); // Replace with your API endpoint
      if (response["data"]["code"] === "200") {
        alert("Order updated successfully.");
        setIconTiles(reorderedIconTiles); // Update the state with the reordered items
      } else {
        alert("Error updating order. Please try again.");
      }
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleEditTile = (e, index) => {
    e.stopPropagation();
    setEditingIndex(index);
  };

  const handleDeleteTile = (e, index) => {
    e.stopPropagation();
    const updatedTiles = iconTiles.filter((_, i) => i !== index);
    setIconTiles(updatedTiles);
  };

  /* const handleAddTile = () => {
        const newTile = { id: '', title: '', icon_image: '', page_link: '', orientation_number: '' };
        setIconTiles([...iconTiles, newTile]);
    }; */

  return (
    <Accordion sx={sectionStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton color="" component="icon">
            <GridViewIcon />
          </IconButton>
          <Typography variant="h7">Icon Tiles</Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: 2,
          }}
        >
          <div style={{ flex: 1 }}>
            <Typography
              variant="body1"
              sx={{
                color: "#424956",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              Section Title
            </Typography>
            <TextField
              fullWidth
              placeholder="Add section title here"
              helperText="Max 20 characters including space"
              variant="outlined"
              sx={{ ...inputStyle, mb: 4 }}
            />
          </div>
          <IconButton
            sx={{ color: "grey", mb: 2 }}
            onClick={(e) => {
              handleEditTile(e);
              handleToggle();
            }}
          >
            {isVisible ? (
              <VisibilityOutlinedIcon />
            ) : (
              <VisibilityOffOutlinedIcon />
            )}
          </IconButton>
        </div>
        <Divider sx={{ mb: 3 }} />
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="iconTiles">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {iconTiles.length > 0 ? (
                  iconTiles.map((tile, index) => (
                    <Draggable
                      key={tile.id}
                      draggableId={tile.id.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <Accordion
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          sx={{
                            backgroundColor: "#eceff1",
                            marginBottom: 2,
                            ...provided.draggableProps.style,
                            borderRadius: 0,
                            boxShadow: 0,
                          }}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <MenuIcon
                                sx={{ cursor: "pointer", marginRight: 2 }}
                              />
                              <Avatar
                                src={
                                  tile.icon_image_file
                                    ? URL.createObjectURL(tile.icon_image_file)
                                    : tile.icon_image
                                } 
                                sx={{
                                  width: 40,
                                  height: 40,
                                  backgroundColor: "white",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 2,
                                  padding: 0.35,
                                  overflow: "hidden",
                                }}
                              />
                              <Typography>{tile.title}</Typography>
                            </Typography>
                            <div
                              style={{
                                marginLeft: "auto",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <IconButton
                                sx={{ mr: 1, color: "grey" }}
                                onClick={() =>
                                  handleVisibilityToggle(
                                    tile.id,
                                    tile.status !== "enabled"
                                  )
                                }
                              >
                                {tile.status === "enabled" ? (
                                  <VisibilityOutlinedIcon />
                                ) : (
                                  <VisibilityOffOutlinedIcon />
                                )}
                              </IconButton>
                              <IconButton
                                sx={{ color: "red" }}
                                onClick={(e) => handleDeleteTile(e, index)}
                              >
                                <DeleteOutlinedIcon />
                              </IconButton>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{
                              padding: 5,
                              pt: 2,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 2,
                              }}
                            >
                              <Avatar
                                src={
                                  tile.icon_image_file
                                    ? URL.createObjectURL(tile.icon_image_file)
                                    : tile.icon_image
                                }
                                sx={{
                                  width: 100,
                                  height: 100,
                                  backgroundColor: "white",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 2,
                                  marginLeft: 3,
                                  padding: 1,
                                  overflow: "hidden",
                                }}
                              />
                              <div>
                                <IconButton
                                  variant="outlined"
                                  component="label"
                                  sx={{ mt: 2, color: "black" }}
                                >
                                  <FileUploadOutlinedIcon />
                                  <input
                                    type="file"
                                    hidden
                                    accept="image/png"
                                    onChange={(e) =>
                                      handleImageUpload(e, index)
                                    }
                                  />
                                </IconButton>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  align="center"
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "Inter",
                                    fontWeight: 500,
                                  }}
                                >
                                  W 96px / H 96px
                                </Typography>
                              </div>
                            </div>
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ marginTop: 1, marginBottom: 1 }}
                              style={{
                                fontSize: 12,
                                fontFamily: "Inter",
                                fontWeight: 500,
                              }}
                            >
                              *Only PNG with transparent background
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                color: "#424956",
                                fontFamily: "Inter",
                                fontWeight: 700,
                                fontSize: 14,
                                mt: 3,
                              }}
                            >
                              Title
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="Write title text here"
                              helperText="Max 12 characters including space"
                              variant="outlined"
                              sx={{
                                ...inputStyle,
                                mb: 4,
                              }}
                              value={tile.title}
                              onChange={(e) => handleTitleChange(e, index)}
                            />
                            <Box
                              sx={{ display: "flex-col", alignItems: "center" }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "#424956",
                                  fontFamily: "Inter",
                                  fontWeight: 700,
                                  fontSize: 14,
                                }}
                              >
                                Link collection page
                              </Typography>
                              <Autocomplete
                                options={[
                                  { label: "None", value: "none" },
                                  ...collectionOptions,
                                ]}
                                getOptionLabel={(option) => option.label || ""}
                                value={
                                  [collectionOptions].find(
                                    (option) =>
                                      option.value === tile.collection ||
                                      option.label === tile.collection_name
                                  ) || {
                                    label: tile.collection_name || "None",
                                    value: tile.collection || "none",
                                    collection_url: tile.collection_url || "",
                                  }
                                }
                                onChange={(event, newValue) =>
                                  handleLinkChange(event, newValue, index)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    sx={{
                                      marginBottom: 2,
                                      ...inputStyle,
                                    }}
                                  />
                                )}
                              />
                            </Box>
                            <Divider sx={{ margin: 0 }}>OR</Divider>
                            <Typography
                              variant="body1"
                              sx={{
                                color: "#424956",
                                fontFamily: "Inter",
                                fontWeight: 700,
                                fontSize: 14,
                              }}
                            >
                              URL to link collection page
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="URL"
                              variant="outlined"
                              sx={{
                                ...inputStyle,
                                marginBottom: 1,
                              }}
                              value={tile.page_link}
                              onChange={(e) => handleURLChange(e, index)}
                              disabled={!tile.isEditable}
                            />
                            <Button
                              onClick={() => handleSaveTile(index)}
                              sx={{ ...buttonStyle, mt: 2, width: 5 }}
                            >
                              Save
                            </Button>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </Draggable>
                  ))
                ) : (
                  <Typography>No icon tiles available</Typography>
                )}
                {provided.placeholder}
                {/* Add Button for adding new tiles */}
                {/*<IconButton variant="contained" sx={{ ...buttonStyle, mt: 1 }} onClick={handleAddTile}>
                                    <AddIcon />
                                </IconButton>*/}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </AccordionDetails>
    </Accordion>
  );
}
